export default __webpack_public_path__ + "static/media/NoEntry.a018ca6d.svg";